import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'iconoir-react';

interface PageNavbarProps {
  title: string;
}

export const PageNavbar: React.FC<PageNavbarProps> = ({ title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (window.confirm('Voulez-vous vraiment vous déconnecter ?')) {
      await logout();
    }
  };

  const getRoleBadge = (role: string) => {
    const badges = {
      super_admin: { label: 'Super Admin', color: '#9b59b6' },
      admin: { label: 'Administrateur', color: '#e74c3c' },
      editor: { label: 'Éditeur', color: '#3498db' },
      visitor: { label: 'Visiteur', color: '#95a5a6' },
    };
    return badges[role as keyof typeof badges] || badges.visitor;
  };

  if (!user) return null;

  const badge = getRoleBadge(user.role);

  return (
    <div className="navbar">
      <div className="navbar-content">
        <div className="navbar-left">
          <h2 className="navbar-brand">{title}</h2>
        </div>
        <div className="navbar-right">
          <div
            className="user-info"
            onClick={() => navigate('/profile')}
            style={{ cursor: 'pointer' }}
            title="Paramètres du profil"
          >
            <div className="user-avatar">
              {user.avatar_url ? (
                <img src={user.avatar_url} alt={user.name} className="user-avatar-image" />
              ) : (
                user.name.charAt(0).toUpperCase()
              )}
            </div>
            <div className="user-details">
              <div className="user-name">{user.name}</div>
              <div className="user-role" style={{ backgroundColor: badge.color }}>
                {badge.label}
              </div>
            </div>
          </div>
          <button className="btn btn-logout" onClick={handleLogout} title="Déconnexion">
            <LogOut width={18} height={18} strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
};
